import React from "react";
import { Message } from "semantic-ui-react";
import { Checkbox } from "./Atoms/inputs/Checkbox";

interface Props {
  className?: string
  visible: boolean
  upgradeMessage: string
  hasConfirmed?: boolean
  onConfirmedChanged?: (confirmed: boolean) => void
}

const UpgradeConfirmation = (props: Props) => props.visible && (
  <div className="margin-top-big">
    <Message className={props.className} color="blue">
      <div dangerouslySetInnerHTML={{ __html: props.upgradeMessage.split("\n").join("<br/>") }}>
      </div>

      {props.onConfirmedChanged != null && <div className="margin-top-large">
        <Checkbox checked={props.hasConfirmed} onChange={() => { props.onConfirmedChanged(!props.hasConfirmed); }} label={RESX.GeneralLabels.ConfirmUpgrade} />
      </div>}
    </Message>
  </div>
);

export default UpgradeConfirmation;